import React, { useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Button } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { Image } from 'expo-image';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "90%",
    gap: 20,
    alignItems: 'center',
    alignSelf: 'center',
  },
  image28x28: {
    width: 28,
    height: 28,
  },
  badge: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'red',
    borderRadius: 10,
    paddingHorizontal: 5,
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
    paddingVertical: 1,
  },
  matchesCount: {
    position: 'absolute',
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
  matchesButtonWrapper: {
    width: AppConsts.TAB_BUTTON_WIDTH,
    height: AppConsts.TAB_BUTTON_HEIGHT,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  matchesButton: {
    width: AppConsts.TAB_BUTTON_WIDTH - 2,
  },
});

type Props = {
  focused: boolean,
};

export default function MatchesButton({ focused }: Props) : React.ReactNode {
  const communityMembership = useSelector((state: RootState) => state.user.communityMembership);

  return (
    <View style={styles.matchesButtonWrapper}>
      <View style={styles.matchesButton}>
        <Link href="/chats" asChild className="nontext">
          <Button active={focused}>
            <Image source={require('@/assets/images/heart28x28.png')} style={styles.image28x28} />
          </Button>
        </Link>
      </View>
      { communityMembership.unread_messages && communityMembership.unread_messages > 0 ?
            (
              <Link href="/chats" asChild>
                <AppText style={styles.badge}>{communityMembership.unread_messages > 99 ? "∞" : "" + communityMembership.unread_messages}</AppText>
              </Link>
            )
          :
            null
      }
      {
        communityMembership.unread_matches && communityMembership.unread_matches > 0 ?
            (
              <Link href="/chats" asChild>
                <AppText style={styles.matchesCount}>{communityMembership.unread_matches > 9 ? "∞" : "" + communityMembership.unread_matches}</AppText>
              </Link>
            )
          :
          null
      }
    </View>
  );
};
